define({
    height : 704,
    width  : 1024
});